import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { postDocumentacaoAVCB } from "./services";

interface UploadState {
  status: "idle" | "loading" | "success" | "error";
  error: string | null;
  responseData: any | null;
}

const initialState: UploadState = {
  status: "idle",
  error: null,
  responseData: null,
};

export const postArquivoParaApi = createAsyncThunk<
  any,
  FormData,
  { rejectValue: string }
>("upload/postArquivo", async (formData, { rejectWithValue }) => {
  try {
    const data = await postDocumentacaoAVCB(formData);
    return data;
  } catch (err: any) {
    const errorMessage =
      err.response?.data?.message || "Falha ao enviar o arquivo.";
    return rejectWithValue(errorMessage);
  }
});

const sliceUploadFile = createSlice({
  name: "upload",
  initialState,
  reducers: {
    resetUploadState: (state) => {
      state.status = "idle";
      state.error = null;
      state.responseData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postArquivoParaApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.responseData = null;
      })
      .addCase(
        postArquivoParaApi.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = "success";
          state.responseData = action.payload;
        },
      )
      .addCase(
        postArquivoParaApi.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload || "Ocorreu um erro desconhecido.";
        },
      );
  },
});

export const { resetUploadState } = sliceUploadFile.actions;
export default sliceUploadFile.reducer;
